import './bootstrap';
import App from './components/App.vue';
import Vapor from 'laravel-vapor';

Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL);
window.Vapor = Vapor;

// Composables
import { createApp } from 'vue';

// Plugins
import { registerPlugins } from '@/pcm/plugins';

const app = createApp(App);

registerPlugins(app);

app.mount('#app');
